import { AxiosResponse } from "axios";
import { APIClient } from "./axiosClient";
import { IAdvertiserAgency } from "./types/_advertiserAgency";
import { PaginationResponse, ResponseData } from "./types/_public";
const api = new APIClient();

const path = '/advertiser-agencies';
const advertiserAgencyApi = {
  advertiserAgencies(params: any): Promise<AxiosResponse<ResponseData<IAdvertiserAgency[]> & PaginationResponse, any>> {
    const url = `${path}`
    return api.get(url, params)
  },
  getAdvertiserAgency(id: string | number, params: any = {}): Promise<AxiosResponse<ResponseData<IAdvertiserAgency>, any>> {
    const url = `${path}/${id}`;
    return api.get(url, params)
  },
  postAdvertiserAgency(dataForm: any): Promise<AxiosResponse<ResponseData<IAdvertiserAgency>, any>> {
    const url = `${path}`;
    return api.post(url, dataForm)
  },
  putAdvertiserAgency(id: string | number, dataForm: any): Promise<AxiosResponse<ResponseData<IAdvertiserAgency>, any>> {
    const url = `${path}/${id}`;
    return api.put(url, dataForm)
  },
  deleteAdvertiserAgency(id: string | number, dataForm: any): Promise<AxiosResponse<ResponseData<IAdvertiserAgency>, any>> {
    const url = `${path}/${id}`;
    return api.delete(url, dataForm)
  },
  putAccountAdvertiserAgency(id: string | number, dataForm: any): Promise<AxiosResponse<ResponseData<IAdvertiserAgency>, any>> {
    const url = `${path}/${id}/account`;
    return api.put(url, dataForm);
  },
  allAdvertiserAgencies(params: any = {}): Promise<AxiosResponse<ResponseData<IAdvertiserAgency>, any>> {
    const url = `/masters/advertiser-agencies`;
    return api.get(url, params)
  },
  getGenerateApiKeyAdvertiserAgency(id: string | number, params: any = {}): Promise<AxiosResponse<ResponseData<IAdvertiserAgency>, any>> {
    const url = `${path}/${id}/refresh`;
    return api.get(url, params)
  },
}
export default advertiserAgencyApi
